import { render, staticRenderFns } from "./hostingSettings.vue?vue&type=template&id=6a3f2a8a&scoped=true"
import script from "./hostingSettings.vue?vue&type=script&lang=js"
export * from "./hostingSettings.vue?vue&type=script&lang=js"
import style0 from "./hostingSettings.vue?vue&type=style&index=0&id=6a3f2a8a&prod&lang=css"
import style1 from "./hostingSettings.vue?vue&type=style&index=1&id=6a3f2a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f2a8a",
  null
  
)

export default component.exports